<!--
@Author: Calvin Green <calvin>
@Date:   2022-06-10T14:26:06+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-07-22T19:22:08+02:00
@Copyright: Diversitude 2022
-->

<script>
import appConfig from "@/app.config";

import { notificationMethods, clientAdminMethods, clientAdminState } from "@/state/helpers";

import store from '@/state/store'

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  mounted() {
    this.refreshAuth();
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  computed:{
    ...clientAdminState,
    loggedIn(){
      return store.getters['auth/loggedIn'];
    }
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...clientAdminMethods,
    clearNotification: notificationMethods.clear,
    refreshAuth(){
      // eslint-disable-next-line no-unused-vars
      const timer = setInterval(() => {
        if (store.getters['auth/loggedIn']){
          store.dispatch('auth/refresh').then((validUser) => {
            if(validUser){
              console.log("Refreshed User");
            }
          })
        }
      }, 400000)
    }
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
